import { Stack, Typography } from "@mui/material";

import { styled } from "@mui/material/styles";

const StyledStack = styled(Stack)(({ theme }) => ({
    borderTopColor: theme.palette.divider,
    borderTopWidth: 1,
    borderTopStyle: "solid",
    borderBottomColor: theme.palette.divider,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    [theme.breakpoints.down("lg")]: {
        "& > *": {
            borderTopColor: theme.palette.divider,
            borderTopWidth: 1,
            borderTopStyle: "solid",
        },
        "& > :first-child": {
            borderTopWidth: 0,
        },
    },
    [theme.breakpoints.up("lg")]: {
        "& > *": {
            borderLeftColor: theme.palette.divider,
            borderLeftWidth: 1,
            borderLeftStyle: "solid",
        },
        "& > :first-child": {
            borderLeftWidth: 0,
        },
    },
}));

export interface ISettingsListItem {
    title: string;
    element: JSX.Element;
}

interface ISettingsListProps {
    items: ISettingsListItem[];
}

const SettingsList: React.FC<ISettingsListProps> = ({ items }) => {
    return (
        <StyledStack
            direction={{
                lg: "row",
            }}
            justifyContent="space-between"
        >
            {items.map((item, index) => (
                <Stack p={2} key={index} spacing={1}>
                    <Typography variant="caption">{item.title}</Typography>
                    {item.element}
                </Stack>
            ))}
        </StyledStack>
    );
};

export default SettingsList;
